import { DocumentationWorkspace } from "../../features/documentation/DocumentationWorkspace";

interface DocumentFlowProps {
    onDismiss: () => void;
    projectId?: string;
    autoStartVoiceToken?: number;
}

export const DocumentFlow = (props: DocumentFlowProps) => {
    return <DocumentationWorkspace {...props} />;
};
